import { SubscriptionIntervalDuration } from './SubscriptionIntervalDuration.ts';

export interface SubscriptionIntervalConfig {
    maxIntervalsPurchaseAheadInFuture: number;
    intervalPrice: number;
    intervalDuration: SubscriptionIntervalDuration;
    subscriptionProRataConfig: SubscriptionProRataConfig;
}

export type SubscriptionProRataConfig =
    | SubscriptionProRataDisabled
    | SubscriptionProRataEnabled;

export type SubscriptionProRataDisabled = Record<string, undefined>;

export type SubscriptionProRataEnabled = {
    dailyPrice: number;
};

export function isSubscriptionProRataEnabled(
    value: SubscriptionProRataConfig | null,
): value is SubscriptionProRataEnabled {
    return (
        value != null &&
        'dailyPrice' in value &&
        typeof value.dailyPrice === 'number'
    );
}
